import ModelState, {localised} from 'spa/state/_util/model';

class SchemesState extends ModelState {
  get method() { return 'GET'; }
  get url() { return '/schemes'; }
  get singular() { return 'scheme'; }
  get plural() { return 'schemes'; }
}

export default SchemesState;



// WEBPACK FOOTER //
// ./spa/state/schemes.jsx